// navBoardsEarly.js — pre-paint board-list filter. BLOCKING, end of <body>
// (same slot as preHide.js): runs after the nav markup is parsed but before
// first paint, so the .navLinkSpan boards + separators are in their FINAL
// state from frame one. External file on purpose: CSP is 'self' + hashes
// only (see staffModeEarly.js / vm-lab/frontend/fouc-fix.md).
//
// Why: leftBar.njk server-renders EVERY board; favouriteBoards.js (deferred)
// used to hide the non-starred ones at DOMContentLoaded — so every page load
// painted the full list and then shrank it one frame later (show-then-hide
// nav churn). This stamp removes that window. The deferred
// favouriteBoards.render() still runs and stays the single source of truth:
// for an already-filtered nav it is an idempotent no-op (same display
// values), and it still owns star creation/coloring, mobile minus, and
// toggle re-renders.
(function() {
  try {
    var list = null;
    var raw = localStorage.getItem('savedFavouriteBoards');
    if (raw === null) {
      // Fresh browser: the default subset lives on the span itself.
      var d = document.querySelector('.navLinkSpan[data-default-boards]');
      if (!d) return;
      list = (d.getAttribute('data-default-boards') || '').split(' ').filter(Boolean);
    } else {
      list = JSON.parse(raw || '[]');
    }

    var uriFromHref = function(href) {
      var m = /^\/([^/]+)\/$/.exec(href || '');
      return m ? m[1] : null;
    };

    document.querySelectorAll('.navLinkSpan').forEach(function(span) {
      var kids = Array.prototype.slice.call(span.children);
      var boardUri = function(el) {
        return el.tagName === 'A' ? uriFromHref(el.getAttribute('href')) : null;
      };

      // Pass 1: board links. [+] /boards.js and other non-board links stay.
      kids.forEach(function(el) {
        var uri = boardUri(el);
        if (uri !== null) {
          el.style.display = (list.indexOf(uri) > -1) ? '' : 'none';
        }
      });

      // Pass 2: separators — same anchoring rule as favouriteBoards.render():
      // for each pair of ADJACENT visible boards keep the first '/' in their
      // gap, hide every other separator.
      var vis = kids.filter(function(el) {
        var u = boardUri(el);
        return u !== null && list.indexOf(u) > -1;
      });
      var keep = {};
      for (var v = 1; v < vis.length; v++) {
        var start = kids.indexOf(vis[v - 1]);
        for (var s = start + 1; s < kids.length; s++) {
          if (boardUri(kids[s]) !== null) break; // safety: hit a board, no sep in gap
          if (kids[s].classList && kids[s].classList.contains('navSep')) { keep[s] = true; break; }
        }
      }
      kids.forEach(function(el, i) {
        if (el.classList && el.classList.contains('navSep')) {
          el.style.display = keep[i] ? '' : 'none';
        }
      });
    });
  } catch (e) { /* storage disabled / unexpected DOM — deferred render() settles it */ }
})();
